module.exports = __webpack_public_path__ + "img/oms2024_logo_3.aede84b4.jpg";